<template>
  <base-modal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_confirm_purchase_purchase }}</h1>

      <p class="games-to-price">
        <span>{{ getBundleData.numberOfGames }}</span> {{ $_getTranslations.home_modals_confirm_purchase_games }} -
        <span>{{ getBundleData.price }}</span> {{ getBundleData.currencyCode }}
      </p>

      <p>{{ $_getTranslations.home_modals_confirm_purchase_playing_more_pt1 }}<br>
        {{ $_getTranslations.home_modals_confirm_purchase_playing_more_pt2 }}
      </p>

      <base-button @button:click="purchaseBundle">
        {{ $_getTranslations.home_modals_confirm_purchase_purchase_now_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import translationMixin from '../../../../common/mixins/translation'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import FailedPurchase from './FailedPurchase'
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful'
import FailedPurchaseOperator from './FailedPurchaseOperator'
import modals from '../../../../common/modals'
import {apiResponseTypeEnum} from '../../../../constants/api'

export default {
  name: 'confirmPurchase',
  emits: ['bundlePurchase'],
  components: {
    BaseModal,
    BaseButton
  },
  mixins: [translationMixin],
  methods: {
    ...mapMutations('common', [
      'storeModalForStore'
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall'
    ]),
    showModal () {
      modals.setupCommonModal({
        afterHideCallback: () => {
          this.storeModalForStore(null)
        }
      })
    },
    purchaseBundle () {
      this.getUserLoginDetails().then(() => {
        const bundleInfo = {
          bundleId: this.bundleId,
          pin: null
        }

        this.chargePinCall({value: bundleInfo}).then(() => {
          if (this.chargePinResponse === apiResponseTypeEnum.OPERATION_SUCCESS) {
            this.$emit('bundlePurchase')
            this.storeModalForStore(ConfirmPurchaseSuccessful)
          } else if (this.chargePinResponse === apiResponseTypeEnum.BILLING_FAILED) {
            this.storeModalForStore(FailedPurchaseOperator)
          } else if (this.chargePinResponse === apiResponseTypeEnum.NO_BALANCE) {
            this.storeModalForStore(FailedPurchase)
          } else {
            this.storeModalForStore(FailedPurchaseOperator)
          }
          this.showModal()
        })
      })
    }
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId'
    ]),
    ...mapGetters('profile', [
      'getBundleData'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchase.vue